/**
 * A support session runs in a frame over the super admin's page, not in a tab
 * of its own. The frame is recognised by its name, which stays the same across
 * every page and reload inside it; nothing outside the frame ever has it.
 */
export const SUPPORT_FRAME_PREFIX = 'ardealy-support:';

/** Posted to the super admin's page when the session in the frame is over. */
export const SUPPORT_FRAME_ENDED_MESSAGE = 'ardealy:support-frame-ended';

export const supportFrameName = (sessionId: string) => `${SUPPORT_FRAME_PREFIX}${sessionId}`;

/** The support session this window is the frame of, or null for any other window. */
export function supportFrameSessionId(): string | null {
    try {
        if (window.self === window.top) return null;
    } catch {
        // A top window we may not read is still a parent: go on.
    }
    const name = window.name || '';
    return name.startsWith(SUPPORT_FRAME_PREFIX) ? name.slice(SUPPORT_FRAME_PREFIX.length) : null;
}
